import type { Story } from '@/store/story-types'

export const RESTAURANT_APP_STORY: Story = {
  id: 'restaurant-app',
  name: 'Bistro Noir — Fine Dining',
  narrative: 'A fine dining restaurant app that showcases the ambiance, highlights signature dishes, and lets guests reserve a table or browse the full menu.',
  goals: ['Showcase restaurant ambiance', 'Highlight menu items', 'Enable table reservations', 'Display full menu'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'Home',
      order: 0,
      status: 'draft',
      elementCount: 5,
      linkedPageId: 'home',
      description: 'Landing page with hero, menu highlights, and reservation section',
      blockRef: { category: 'restaurant', blockId: 'rest-hero' },
    },
    {
      id: 'pg-menu',
      title: 'Full Menu',
      order: 1,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'menu',
      description: 'Complete restaurant menu with categories and pricing',
      blockRef: { category: 'restaurant', blockId: 'full-menu' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Hero',
      description: 'Guest sees the restaurant hero section',
      steps: [
        { type: 'given', text: 'the guest is on the homepage' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero image, restaurant name, and reserve button are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Browse Menu Highlights',
      description: 'Guest views featured dishes on the homepage',
      steps: [
        { type: 'given', text: 'the guest is on the homepage' },
        { type: 'when', text: 'they scroll to menu highlights' },
        { type: 'then', text: 'signature dishes with images and prices are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Make Reservation',
      description: 'Guest reserves a table',
      steps: [
        { type: 'given', text: 'the guest is on the homepage' },
        { type: 'when', text: 'they fill in the reservation form with date, time, and party size' },
        { type: 'then', text: 'the reservation is submitted and a confirmation message appears', linkedPageId: 'home', linkedFlowId: 'submitReservation' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'View Full Menu',
      description: 'Guest browses the complete menu',
      steps: [
        { type: 'given', text: 'the guest is on the homepage' },
        { type: 'when', text: 'they navigate to the Full Menu page' },
        { type: 'then', text: 'menu categories with items, descriptions, and prices are displayed', linkedPageId: 'menu' },
      ],
    },
    {
      id: 'bdd-5',
      name: 'Place Order from Menu',
      description: 'Guest adds items from the full menu',
      steps: [
        { type: 'given', text: 'the guest is on the Full Menu page' },
        { type: 'when', text: 'they tap Add on a menu item' },
        { type: 'then', text: 'the item is added to the order summary', linkedPageId: 'menu', linkedFlowId: 'addToOrder' },
      ],
    },
  ],
}
